import { apiUrl } from "../../config/base.js";
import axios from 'axios';

export default {

	cancel(protest_request_uid, payload) {
		return axios.post(apiUrl + '/user-properties/' + protest_request_uid + '/cancel', { payload: payload });
	},
}

